import { Injectable } from '@angular/core';
import { EagleInfoClientError } from '@main-shared-lib';
import { WireTalkClient } from '@wire-talk/client';
import { DataService } from './data.service';


@Injectable({
  providedIn: 'root'
})
export class ChatService {
  static isOnline: boolean;
  static chatUnreadCount: number;
  wireTalkController?: WireTalkClient;
  chatMainOpen;

  constructor(private dataService: DataService) { }

  runChatController(getWsToken: () => Promise<string>) {
    if (!this.dataService.profileType && !this.dataService.isSuperAdmin) {
      throw new EagleInfoClientError('profileType is undefined');
    }

    const chatInfo = this.dataService.getChatInfo();

    this.wireTalkController = new WireTalkClient(
      chatInfo.chatServerUrl || '',
      getWsToken,
      chatInfo._id,
      chatInfo.names || 'Eagle Info Solutions',
      chatInfo.photo || '',
      ''
    );
  }
}
